export default __webpack_public_path__ + "static/media/virtual.d6cac13e.svg";